<template>
    <v-container fluid>
      <v-data-table locale="fr" :headers="headers" @click:row="goto" :search="search"
        no-data-text="Aucun Avis d&#39;Appel à Concurrence disponible" :items="this.$store.getters['Auth/getListAvis']"
        sort-by="publiDate" class="elevation-1 mb-5 px-5">
        <template v-slot:[`item.colorState`]="{ item }">
          <!-- v-if="item.noticeType.id != 1 && item.noticeType.id != 8 && item.noticeType.id != 9" -->
          <v-icon medium :color="item.colorState.colorCode">mdi-circle</v-icon>
        </template>
        <template v-slot:[`item.deadline`]="{ item }">{{
          item.deadline ? item.deadline : "--" | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z")
        }}</template>
        <template v-slot:[`item.publiDate`]="{ item }">{{
          item.publiDate | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z")
        }}</template>
        <template v-slot:top>
          <v-toolbar flat color="white" class="mb-5">
            <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">Liste détaillée des avis d’appel à la
              Concurrence</v-toolbar-title>
            <v-divider class="mx-4" inset vertical v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Recherchez un avis" single-line
              hide-details></v-text-field>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-container>
  </template>
    
  <script>
  import { mapActions } from "vuex";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  
  export default {
    components: { DatePicker },
    data: () => ({
      search: "",
      items: [
        {
          text: "Tableau de bord",
          disabled: false,
          href: "/dashboard"
        },
        {
          text: "Mes Avis",
          disabled: true
        }
      ],
      dog: true,
      noticePpm: [
        {
          id: 1,
          title: "Réparation route nationale"
        }
      ],
      noticeType: [],
      notice: {
        object: "",
        publi_date: null,
        open_date: null,
        deadline: null,
        doc: 0,
        type: [],
        ppm: [],
        file: [],
        file_letter: []
      },
      dialog: false,
      headers: [
        {
          text: " Statuts des avis en cours ou expirés",
          align: "start",
          sortable: false,
          value: "colorState"
        },
        {
          text: "Objet de l’avis",
          sortable: true,
          value: "object"
        },
        {
          text: "Date/heure de publication de l’avis",
          sortable: true,
          value: "publiDate"
        },
        { text: "Date/heure limite de remise des plis (Expression d’Intérêts / Offres / Propositions)", value: "deadline", sortable: true },
        { text: "Types d'avis", value: "noticeType.title", sortable: true },
        { text: "PPM", value: "ppm.title", sortable: true }
      ],
      desserts: [],
      editedIndex: -1
    }),
    filters: {
      date(val) {
        return val ? val.toLocaleString() : "";
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? " Création d’un nouvel avis d’appel à la concurrence" : "Création du Plan de Passation des Marchés";
      }
    },
    watch: {
      dialog(val) {
        val || this.close();
      }
    },
    created() {
      const cur_year = new Date().getFullYear();
      this.$store.dispatch("Auth/loadAllPPMPublished", cur_year);
      this.$store.dispatch("Auth/loadAllValidatedNotice");
      this.$store.dispatch("Auth/loadAllDoc");
      this.$store.dispatch("Auth/getData");
    },
    methods: {
      ...mapActions({
        loadAllNotice: "Auth/loadAllValidatedNotice"
      }),
      goto(value) {
        const { id } = value;
        this.$router.push({ name: "RegshowAvis", params: { id: id } });
      },
      getPPM(item) {
        console.log(item);
        this.$router.push({ name: "user", params: { ppm: item } });
      },
  
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = { ...this.defaultItem };
          this.editedIndex = -1;
        });
      },
  
      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      }
    }
  };
  </script>
  <style>
  .vue-daterange-picker {
    width: 100% !important;
  }
  
  .mx-datepicker {
    width: 100% !important;
  }
  
  .w-62em {
    height: 62em !important;
    width: 100% !important;
  }
  
  .v-card__text {
    width: 100% !important;
  }
  
  .vue-friendly-iframe iframe {
    width: 100% !important;
    height: 62em !important;
  }
  </style>
    